module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat.ba8fa2e31ebacddacdcbf62f9ec6ea96.png";